export default "__VITE_ASSET__uvkJDgHi__"